import { Box, FactBox, Typography } from 'enova-frontend-components';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, useFormState } from 'react-hook-form';

import { AboutFormControlProps } from '../types';
import { ErrorMessage } from '../errors';

import { hasSelectedHeatingSource } from './utils';
import { Elektrisitet } from './elektrisitet';
import { Ved } from './ved';
import { Solenergi } from './solenergi';
import { Varmepumpe } from './varmepumpe';
import { Fjernvarme } from './fjernvarme';
import { Bioenergi } from './bioenergi';
import { Olje } from './olje';
import { Gass } from './gass';

export const HeatingForm: FC<AboutFormControlProps> = ({ control }) => {
  const { t } = useTranslation();
  const { errors } = useFormState({ control });

  return (
    <FactBox title={t('register.tekniskUtstyr.oppvarming.title')} error={!!errors.oppvarmingSelection}>
      <Typography variant="label">{t('register.tekniskUtstyr.oppvarming.description')}</Typography>

      <Controller
        name="oppvarmingSelection"
        control={control}
        rules={{
          validate: (_, formValues) => {
            // Validate that at least one heating source is selected,
            // and that the selected sources is not used as "Tappevann"
            if (!hasSelectedHeatingSource(formValues)) {
              return t('register.tekniskUtstyr.noSelection');
            }
            return true;
          }
        }}
        render={({ fieldState }) => (
          <Box>
            <Elektrisitet control={control} />
            <Fjernvarme control={control} />
            <Bioenergi control={control} />
            <Varmepumpe control={control} />
            <Solenergi control={control} />
            <Olje control={control} />
            <Ved control={control} />
            <Gass control={control} />
            {fieldState.error && <ErrorMessage error={fieldState.error} />}
          </Box>
        )}
      />
    </FactBox>
  );
};
